import type { TourConfig } from '../../types/tour.types'

// Getting Started / onboarding home. Uses stable `.ob__*` view classes, so no view edits are
// needed. Teaches context first, controls last (adult-learning order, like the dashboard tour).
const onboardingTour: TourConfig = {
  id: 'onboarding',
  title: 'Get set up',
  module: 'Getting Started',
  routeName: 'Onboarding',
  order: 0,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Your launchpad into TAMI',
      body: 'This is your **Getting Started** hub. It turns your questionnaire answers into a short, personalised checklist, so your first session finds real leads instead of staring at a blank screen.',
    },
    {
      id: 'progress',
      target: '.ob__progress',
      placement: 'bottom',
      title: 'Track your setup',
      body: 'Your **setup progress** fills in as you complete the recommended steps. We auto-detect most of them, so it updates on its own as you use TAMI.',
    },
    {
      id: 'recommended',
      target: '.ob__path',
      placement: 'top',
      title: 'Your recommended next steps',
      body: 'These are picked for you from your answers — run your first search, enrich a list, connect your CRM. Hit **Revisit** on any step to jump straight into it.',
    },
    {
      id: 'retake',
      target: '.ob__retake',
      placement: 'bottom',
      title: 'Change your answers anytime',
      body: 'Priorities shifted? **Retake the questionnaire** to re-tune these recommendations to what you need now.',
    },
    {
      id: 'start',
      target: '.ob__done',
      placement: 'top',
      // Only shown once every prerequisite is complete, so skip it silently otherwise.
      optional: true,
      title: 'Then go find leads',
      body: 'Once every step is done, **Start searching** drops you straight into the List Builder to run your first real search.',
    },
  ],
}

export default onboardingTour
